import DropDownList from "@/components/Dropdown";
import { ListCountry } from "@/constants/country";
import { ListGender, ListTypeTa } from "@/constants/default";
import { EnumTypeTa } from "@/constants/enum";
import { TenantForm } from "@/types/tenant.type";
import { emailRegex } from "@/utils/regex";
import { Controller, useFormContext } from "react-hook-form";
import { useTranslation } from "react-i18next";

export default function Information() {
    const {t} = useTranslation()
    const listGenders = ListGender();
    const listCountries = ListCountry();
    const listTypeTas = ListTypeTa();
    const {register, formState: { errors }, control, watch} = useFormContext<TenantForm>()

    return (
        <>
            {/* <div className="mb-3">
                <label className="mb-1 block text-black dark:text-white">
                    {t("tenant.no")}
                </label>
                <input
                    type="text"
                    placeholder={t("placeholder.ref_no")}
                    className="w-full rounded border-[1.5px] border-stroke bg-transparent py-1.5 px-2 outline-none transition focus:border-primary active:border-primary disabled:cursor-default disabled:bg-whiter dark:border-form-strokedark dark:bg-form-input dark:focus:border-primary dark:text-white"
                    {...register("no", {required: t("validation.required")})}
                />
                { errors.name && <p className="mt-1 text-rose-600">{errors.name.message}</p>}
            </div> */}
            <div className="mb-3">
                <label className="mb-1 block text-black dark:text-white">
                    {t("tenant.name")}
                </label>
                <input
                    type="text"
                    placeholder={t("placeholder.name")}
                    className="w-full rounded border-[1.5px] border-stroke bg-transparent py-1.5 px-2 outline-none transition focus:border-primary active:border-primary disabled:cursor-default disabled:bg-whiter dark:border-form-strokedark dark:bg-form-input dark:focus:border-primary dark:text-white"
                    {...register("name", {required: t("validation.required")})}
                />
                { errors.name && <p className="mt-1 text-rose-600">{errors.name.message}</p>}
            </div>
            <div className="mb-3">
                <label className="mb-1 block dark:text-white">
                    {t("tenant.gender")}
                </label>
                <Controller
                    name="gender"
                    control={control}
                    defaultValue={listGenders[0].value}
                    render={({field: {onChange, value}}) => <DropDownList selected={value} setSelected={onChange} list={listGenders} />}
                />
            </div>
            <div className="mb-3">
                <label className="mb-1 block text-black dark:text-white">
                    {t("tenant.email")}
                </label>
                <input
                    type="email"
                    placeholder={t("placeholder.email")}
                    className="w-full rounded border-[1.5px] border-stroke bg-transparent py-1.5 px-2 outline-none transition focus:border-primary active:border-primary disabled:cursor-default disabled:bg-whiter dark:border-form-strokedark dark:bg-form-input dark:focus:border-primary dark:text-white"
                    {...register("email", {pattern: {value: emailRegex, message: t("validation.email_valid")}})}
                />
                { errors.email && <p className="mt-1 text-rose-600">{errors.email.message}</p>}
            </div>
            <div className="mb-3">
                <label className="mb-1 block text-black dark:text-white">
                    {t("tenant.contact_no")}
                </label>
                <input
                    type="text"
                    placeholder={t("placeholder.contact_no")}
                    className="w-full rounded border-[1.5px] border-stroke bg-transparent py-1.5 px-2 outline-none transition focus:border-primary active:border-primary disabled:cursor-default disabled:bg-whiter dark:border-form-strokedark dark:bg-form-input dark:focus:border-primary dark:text-white"
                    {...register("contact_no")}
                />
                { errors.contact_no && <p className="mt-1 text-rose-600">{errors.contact_no.message}</p>}
            </div>
            <div className="mb-3">
                <label className="mb-1 block text-black dark:text-white">
                    {t("tenant.access_card")}
                </label>
                <input
                    type="text"
                    placeholder={t("placeholder.access_card")}
                    className="w-full rounded border-[1.5px] border-stroke bg-transparent py-1.5 px-2 outline-none transition focus:border-primary active:border-primary disabled:cursor-default disabled:bg-whiter dark:border-form-strokedark dark:bg-form-input dark:focus:border-primary dark:text-white"
                    {...register("access_card")}
                />
                { errors.access_card && <p className="mt-1 text-rose-600">{errors.access_card.message}</p>}
            </div>
            <div className="mb-3">
                <label className="mb-1 block dark:text-white">
                    {t("tenant.type")}
                </label>
                <Controller
                    name="type"
                    control={control}
                    defaultValue={listTypeTas[0].value}
                    render={({field: {onChange, value}}) => <DropDownList selected={value} setSelected={onChange} list={listTypeTas} />}
                />
            </div>
            <div className="mb-3">
                <label className="mb-1 block text-black dark:text-white">
                    {t("tenant.identity_number")}
                </label>
                <input
                    type="text"
                    placeholder={t("placeholder.identity_number")}
                    className="w-full rounded border-[1.5px] border-stroke bg-transparent py-1.5 px-2 outline-none transition focus:border-primary active:border-primary disabled:cursor-default disabled:bg-whiter dark:border-form-strokedark dark:bg-form-input dark:focus:border-primary dark:text-white"
                    {...register("identity_number")}
                />
                { errors.identity_number && <p className="mt-1 text-rose-600">{errors.identity_number.message}</p>}
            </div>
            <div className="mb-3">
                <label className="mb-1 block dark:text-white">
                    {t("tenant.nationality")}
                </label>
                <Controller
                    name="nationality"
                    control={control}
                    rules={{required: t("validation.required")}}
                    render={({field: {onChange, value}}) => <DropDownList selected={value} setSelected={onChange} list={listCountries} />}
                />
                { errors.nationality && <p className="mt-1 text-rose-600">{errors.nationality.message}</p>}
            </div>
            {
                watch("type") === EnumTypeTa.NORMAL &&  <div className="mb-3">
                    <label className="mb-1 block text-black dark:text-white">
                        {t("tenant.fin_expiry")}
                    </label>
                    <input
                        type="date"
                        placeholder={t("placeholder.business_unit_account")}
                        className="custom-input-date-1 w-full rounded border-[1.5px] text-black dark:text-white border-stroke bg-transparent py-1.5 px-2 outline-none transition focus:border-primary active:border-primary dark:border-form-strokedark dark:bg-form-input dark:focus:border-primary disabled:opacity-75"
                        {...register("fin_expiry", {required: t("validation.required")})}
                    />
                    { errors.fin_expiry && <p className="mt-1 text-rose-600">{errors.fin_expiry.message}</p>}
                </div>
            }
           
        </>
    )
}
